import type { T_CountryCodeMenuProps } from '@fe/types/modules/localization/common/client/types';
import { useContext, useRef, useEffect } from 'preact/hooks';

import { CountryCodeSelectorContext } from '@/context/CountryCodeSelectorContext';

export default function CountryCodeMenu({ children }: T_CountryCodeMenuProps) {
  const { isOpen, setIsOpen } = useContext(CountryCodeSelectorContext);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !e.composedPath().includes(ref.current)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const childrenArray = Array.isArray(children) ? children : [children];

  return (
    <div className='relative w-full max-w-xs' ref={ref}>
      <div onClick={() => setIsOpen((o) => !o)}>{childrenArray[0]}</div>
      {isOpen && <div onClick={(e) => e.stopPropagation()}>{childrenArray[1]}</div>}
    </div>
  );
}
